import { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { disableBlackout, enableBlackout } from "../../redux/Slice/modalSlice";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { Background, Head, ModalClose } from "./styled";
import IconCloseSvg from "../Auth/assets/IconCloseSvg";
import { useScrollbarWidth } from "../../hooks/useScrollWidth";
import { useFooterPlayer } from "../../contexts/FooterPlayerContext";

const setModalClass = (openingDirection) => {
  switch (openingDirection) {
    case "fullWidth":
      return "blackPage";
    case "onRight":
      return "onRight";
    case "fromBottom":
      return "fromBottom";
    case "onRightMenu":
      return "onRightMenu";
    default:
      return "";
  }
};

const dialogRoot = document.getElementById("modal-root");

export const Dialog = ({
  onClose,
  isListenClickOutside = true,
  openingDirection,
  zIndex,
  backgroundColor,
  isOpen,
  isLast,
  showBlackout,
  title,
  children,
  modalName,
}) => {
  const ref = useRef(null);
  const dispatch = useDispatch();

  const { scrollbarWidth, recalculateScrollbarWidth } = useScrollbarWidth();

  const { footerPlayerRef } = useFooterPlayer();

  useEffect(() => {
    if (!isOpen) return;

    recalculateScrollbarWidth();
  }, [recalculateScrollbarWidth, isOpen]);

  useEffect(() => {
    if (showBlackout && isOpen) {
      dispatch(enableBlackout());

      return () => {
        dispatch(disableBlackout());
      };
    }
  }, [showBlackout, dispatch, isOpen]);

  useOnClickOutside(ref, onClose, isListenClickOutside);

  return ReactDOM.createPortal(
    <CSSTransition
      in={isOpen}
      timeout={100}
      classNames={setModalClass(openingDirection)}
      unmountOnExit
    >
      <Background
        modalName={modalName}
        ref={ref}
        isLast={isLast}
        ZIndex={zIndex}
        backgroundColor={backgroundColor || "rgba(34, 34, 34, 0.9)"}
        openingDirection={openingDirection}
        scrollbarWidth={scrollbarWidth}
        footerPlayerHeight={footerPlayerRef.current?.offsetHeight ?? 0}
      >
        <Head modalName={modalName}>
          <ModalClose onClick={onClose}>
            <IconCloseSvg />
          </ModalClose>
        </Head>
        {children}
      </Background>
    </CSSTransition>,
    dialogRoot,
  );
};
